import { Navigate, useLocation } from 'react-router-dom';

import { useUserAttributes } from '@/hooks/queries/use-user-attributes';
import { isInstitutionalUserSegment } from '@/utils/user-segment';
import LoadingPage from './loading';

const DEFAULT_TARGET_PATH = '/onboarding';

/**
 * In most cases, the routes of the onboarding and institutional onboarding don't coincide.
 * However, there are some cases where they do, such as the futures index page and the verification status page.
 *
 * We preserve the pathname in these cases to avoid redirecting to the default path.
 */
const PRESERVE_PATHS = ['/futures', '/futures/appropriateness-test', '/onboarding/verification/status'] as const;

const INSTITUTION_PATH_PREFIX = '/institution';
const INSTITUTION_PATH_PREFIX_REGEX = new RegExp(`^${INSTITUTION_PATH_PREFIX}`);

const UserSegmentRedirect = () => {
  const { isLoading, data: userAttributes } = useUserAttributes();
  const { pathname } = useLocation();
  const { segment: userSegment } = userAttributes ?? {};
  const basePathname = pathname.replace(INSTITUTION_PATH_PREFIX_REGEX, '');
  let targetPath = DEFAULT_TARGET_PATH;

  if (PRESERVE_PATHS.includes(basePathname as (typeof PRESERVE_PATHS)[number])) {
    targetPath = basePathname;
  }

  if (isInstitutionalUserSegment(userSegment)) {
    targetPath = `${INSTITUTION_PATH_PREFIX}${targetPath}`;
  }

  if (isLoading) return <LoadingPage />;

  return <Navigate to={targetPath} replace />;
};
UserSegmentRedirect.displayName = 'UserSegmentRedirect';

export default UserSegmentRedirect;
